import React, { memo } from 'react';

import { Box } from '@mui/material';
import { DateFieldCDS } from 'app/shared/componentsRestyled/coreDesignSystem/form';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

import { COMMON_DATETIME_FORMAT, MIN_CALENDAR_DATE } from 'constants/date';

import { dateFieldWrapperStyles, dateFilterWrapperStyles } from './LogHistoryDateFilter.styles';
import { LogHistoryDateFilterTestIds } from './LogHistoryDateFilter.testIds';

const LogHistoryDateFilter = ({ fromDate, toDate, onFromDateChange, onToDateChange }) => {
  const currentDate = dayjs();

  return (
    <Box sx={dateFilterWrapperStyles}>
      <Box sx={dateFieldWrapperStyles}>
        <DateFieldCDS
          withTime
          allowKeyboardControl={false}
          dataTestId={LogHistoryDateFilterTestIds.START_DATE}
          format={COMMON_DATETIME_FORMAT}
          label="Start Date"
          maxDate={toDate}
          minDate={MIN_CALENDAR_DATE}
          value={fromDate}
          width="auto"
          onBlur={onFromDateChange}
          onChange={onFromDateChange}
          onFocus={onFromDateChange}
        />
      </Box>

      <Box sx={dateFieldWrapperStyles}>
        <DateFieldCDS
          withTime
          allowKeyboardControl={false}
          dataTestId={LogHistoryDateFilterTestIds.END_DATE}
          format={COMMON_DATETIME_FORMAT}
          label="End Date"
          maxDate={currentDate}
          minDate={fromDate}
          value={toDate}
          width="auto"
          onBlur={onToDateChange}
          onChange={onToDateChange}
          onFocus={onToDateChange}
        />
      </Box>
    </Box>
  );
};

LogHistoryDateFilter.propTypes = {
  fromDate: PropTypes.object.isRequired,
  toDate: PropTypes.object.isRequired,
  onFromDateChange: PropTypes.func.isRequired,
  onToDateChange: PropTypes.func.isRequired,
};

export default memo(LogHistoryDateFilter);
